var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_44_790)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6817 15.4557V17.2739H16.8635V20.0012H18.6817V28.183H22.3181V20.0012H24.7363L25.0453 17.2739H22.3181V15.683C22.3181 14.9467 22.3908 14.5557 23.5271 14.5557H25.0453V11.8193H22.609C19.6999 11.8194 18.6817 13.183 18.6817 15.4557Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 0.000976562C9.4543 0.000976562 0.5 8.95527 0.5 20.001C0.5 31.0467 9.4543 40.001 20.5 40.001C31.5457 40.001 40.5 31.0467 40.5 20.001C40.5 8.95527 31.5457 0.000976562 20.5 0.000976562ZM20.5 38.1828C10.4584 38.1828 2.3182 30.0425 2.3182 20.001C2.3182 9.95941 10.4584 1.81918 20.5 1.81918C30.5416 1.81918 38.6818 9.95941 38.6818 20.001C38.6818 30.0425 30.5416 38.1828 20.5 38.1828Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_44_790"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.5 0.000976562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.c260ee644c7976022bd0b907c243f11a.svg";
export { ForwardRef as ReactComponent };